import { DEFAULT_ERROR_MESSAGE, FAILURE_HEADER, SUCCESS_HEADER } from 'common/config';
import { Action, MessageType } from 'common/enums';
import { appStateActions } from 'common/redux/app-state';
import { AppDispatch } from 'common/redux/core/store.config';
import { UserRoleInfo } from 'modules/admin-roles-management/models/role-management.model';
import { UserService } from 'modules/user-management/redux/user.service';
import { PERMISSION_ASSIGN_FAIILED, PERMISSION_EDIT_MESSAGE } from '../config/user.config';
import { ApiResult } from 'common/models';
import { Dispatch, SetStateAction } from 'react';
import { AssignRoleApiPayload } from '../models/user.model';

export const assignUserRoleUtility = async (
    data: AssignRoleApiPayload,
    dispatch: AppDispatch,
    onSucces: (param: boolean) => void,
    action: Action
) => {
    let response: ApiResult<boolean> | undefined;
    if (action === Action.Create) response = await UserService.assignRole(data);
    else if (action === Action.Edit) response = await UserService.editRole(data);
    if ((response?.hasErrors && response.errors?.length > 0) || !response?.value) {
        const msg = !response?.value ? PERMISSION_ASSIGN_FAIILED : DEFAULT_ERROR_MESSAGE;
        dispatch({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: FAILURE_HEADER,
                message: msg,
                type: MessageType.Error
            }
        });
    } else if (response?.value) {
        onSucces(true);
        dispatch({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: SUCCESS_HEADER,
                message: PERMISSION_EDIT_MESSAGE,
                type: MessageType.Success
            }
        });
    }
    dispatch({
        type: appStateActions.showLoader.type,
        payload: false
    });
};

export const addRoles = (
    val: string,
    rolesList: string[],
    setSelectedRoles: Dispatch<SetStateAction<string[]>>,
    action: Action
) => {
    if (action === Action.Edit) {
        if (!rolesList.includes(val)) {
            setSelectedRoles([...rolesList, val]);
        } else if (rolesList.includes(val)) {
            const uniqueRoles = rolesList.filter((ele: string) => ele != val);
            setSelectedRoles(uniqueRoles);
        }
    } else if (!rolesList.includes(val)) {
        setSelectedRoles([...rolesList, val]);
    } else if (rolesList.includes(val)) {
        const uniqueRoles = rolesList.filter((ele: string) => ele != val);
        setSelectedRoles(uniqueRoles);
    }
};

export const getUserOptionData = (data: UserRoleInfo) => {
    if (data?.firstName && data?.lastName) {
        return `${data.firstName} ${data.lastName}`;
    }
    if (data?.firstName && !data?.lastName) {
        return `${data.firstName} ${data.firstName}`;
    }
    return `${data.firstName} ${data.firstName}`;
};

export const getPermissionListWithFullName = (permissionList: UserRoleInfo[]) => {
    if (permissionList && permissionList.length > 0) {
        let fullName = '';
        const permissionRowData = permissionList.map((item) => {
            if (item.firstName.length > 0 && item.lastName.length > 0)
                fullName = `${item.firstName} ${item.lastName}`;
            if (item.firstName.length > 0 && item.lastName.length === 0) fullName = item.firstName;
            if (item.firstName.length === 0 && item.lastName.length > 0) fullName = item.lastName;

            return { ...item, fullName: fullName };
        });
        return [...permissionRowData];
    }
    return [];
};
